import { Directive } from '@angular/core';
import { NG_VALIDATORS, AbstractControl, Validator, ValidationErrors, ValidatorFn } from '@angular/forms';

export function nameValidator(): ValidatorFn {

  const NAME_REGEXP = /^[a-zA-Z\s]*$/i;

  return (control: AbstractControl): ValidationErrors | null => {
    const isValid = NAME_REGEXP.test(control.value);

    if (isValid) {
      return null;
    } else {
      return {
        nameValidator: {
          valid: false,
        },
      };
    }
  };

}

@Directive({
  selector: '[appNameValidator]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: NameValidatorDirective,
    multi: true,
  }],
})
export class NameValidatorDirective implements Validator {

  constructor() {
  }

  public validate(control: AbstractControl): ValidationErrors | null {
    return nameValidator()(control);
  }

}